/**
 * "In the news" media coverage.
 *
 * A simple data file: each entry is one piece of external coverage. Add an item
 * (same shape) and the In-the-news grid on /press renders it, linking out to the
 * article. When the array is empty, the "Coverage coming soon" state shows
 * instead — no component edits either way. List entries newest first.
 */
export type Coverage = {
  /** Publication / outlet name, e.g. "Inman". */
  outlet: string;
  /** ISO date, YYYY-MM-DD. */
  date: string;
  /** Article headline. */
  headline: string;
  /** External article URL — opens in a new tab. */
  url: string;
  /** One-line excerpt or description. */
  excerpt: string;
  /** Optional outlet logo (path or URL) shown beside the outlet name. */
  logo?: string;
};

// Add new entries at the top (newest first). `logo` is optional — omit it
// unless the outlet's mark is licensed for our use.
export const coverage: Coverage[] = [
  {
    outlet: "Propt by Craig Rowe",
    date: "2026-10-06",
    headline: "A Look At Compaire",
    url: "https://www.linkedin.com/pulse/look-compaire-craig-rowe-cgr1c",
    excerpt:
      "Brokerage tech advisor Craig Rowe walks through Compaire's brokerage dashboards, newsroom, and agent reviews, and why an upfront, side-by-side view gives agents more transparency before a move.",
  },
  {
    outlet: "Inman",
    date: "2026-07-21",
    headline: "Compaire offers agents a new way to shop for their next brokerage",
    url: "https://www.inman.com/2026/07/21/agent-recruiting-platform-compaire/",
    excerpt:
      "Inman covers Compaire's launch and its private, agent-side approach to weighing brokerages and teams.",
  },
  {
    outlet: "Real Estate News",
    date: "2026-07-21",
    headline: "Compaire unveils platform for brokerage, team comparisons",
    url: "https://www.realestatenews.com/2026/07/21/compass-unveils-ai-assistant-brokerage-comparison-tool-launches",
    excerpt:
      "Real Estate News highlights Compaire's early-access launch: a private marketplace for agents to compare brokerages and teams before a move.",
  },
];
